<!--
  COTI-502: una medida del pliego con su mínimo y su aviso, apilados en una columna.
-->
<template>
  <el-col :span="spanColumn">
    <el-row>
      <custom-input-number
        v-model="valor"
        :label="label"
        :spanColumn="24"
        :settings="settingsInput"
      />
    </el-row>

    <el-row>
      <custom-data
        :label="labelMinimo"
        :spanColumn="24"
        :data="minimoFormateado"
        space="shrink"
      />
    </el-row>

    <div
      v-if="noLlegaAlMinimo"
      class="aviso-minimo"
    >
      {{ mensajeMinimo }}
    </div>
  </el-col>
</template>

<script setup>
import { computed } from 'vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import CustomData from '@/shared/components/custom_data.vue';
import { noLlegaAlMinimoPliego } from '@/shared/utils/margenes_pliego_maquina.js';

const props = defineProps({
  /** Medida que entra en máquina, en la unidad de display. */
  modelValue: { type: [Number, String], default: null },
  /** Título del campo editable, con su unidad: "Ancho pliego (mm)". */
  label: { type: String, required: true },
  /** Título del mínimo: "Ancho mín. pliego (mm)". */
  labelMinimo: { type: String, required: true },
  /**
   * Lo que la imposición necesita, en la misma unidad que `modelValue`. Tiene que venir del
   * cálculo actual, no de AnchoMinimoMaterial / LargoMinimoMaterial (copia persistida).
   */
  minimo: { type: [Number, String], default: 0 },
  /** Decimales con los que se muestra el mínimo: 2 en mm, 4 en pulgadas. */
  decimales: { type: Number, default: 2 },
  mensajeMinimo: { type: String, default: 'No llega al mínimo' },
  spanColumn: { type: Number, default: 4 },
  /** Se mezcla con la configuración del input; sirve para deshabilitarlo o afinar el paso. */
  settings: { type: Object, default: () => ({}) },
});

const emits = defineEmits(['update:modelValue']);

const valor = computed({
  get: () => props.modelValue,
  set: (nuevo) => emits('update:modelValue', nuevo),
});

const settingsInput = computed(() => ({
  placeholder: props.label,
  min: 0,
  precision: 4,
  step: 0.00001,
  controls: false,
  ...props.settings,
}));

const minimoFormateado = computed(() => Number(props.minimo ?? 0).toFixed(props.decimales));

/**
 * El aviso compara contra lo que se ve en el campo, no contra el material.
 *
 * Con los dos números uno encima del otro, avisar sobre un valor que no está en pantalla
 * confundiría más de lo que ayuda. Un campo vacío no dispara el aviso: todavía no hay nada
 * que comparar.
 */
const noLlegaAlMinimo = computed(() =>
  noLlegaAlMinimoPliego({ medida: props.modelValue, minimo: props.minimo }),
);
</script>

<style scoped>
.aviso-minimo {
  color: #d93025;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  margin-top: 2px;
}
</style>
